import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  ModalHeader,
  FormGroup,
} from "shards-react";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { SelectYears, CheckboxYears } from "shared/components";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import { saveAs } from "file-saver";

const axios = require("axios").default;
const ModalClose = styled.a`
  color: black;
  cursor: pointer;
  position: absolute;
  right: 20px;
  :hover {
    color: black;
  }
`;
const StyledModalFooter = styled(ModalFooter)``;

const ModalDeleteContentMain = (props) => {
  const { token } = useToken();
  const { open, toggle, indicatorsId } = props;
  const [filePath, setFilePath] = useState(null);
  const [loading, setLoading] = useState(false);
  const [indicatorsdataId, setIndicatorsdataId] = useState(null);
  const [yearId, setyearId] = useState(null);
  const [yearsName, setYearsName] = useState(null);

  const [selectYear, setSelectYear] = useState([]);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };
  const checkIndicator = [ 14,44];
  const checkIndicatorExcel1 = [7];

  const download = () => {
    if (token) {
      if (checkIndicator.includes(indicatorsdataId)) {
        window.open(
          `${baseUrl}/v1/table${44}/table${44}Export3Year?yearNo=${yearsName}`
        );
      } 
      else if (checkIndicatorExcel1.includes(indicatorsdataId)) {
        window.open(
          `${baseUrl}/v1/table${indicatorsdataId}/table${indicatorsdataId}Excel1?yearNo=${yearsName}`
        );
      } else if (indicatorsdataId === 42){
        window.open(
          `${baseUrl}/v1/table${indicatorsdataId}/table${indicatorsdataId}Excel?yearNo=2543`
        );
      }
      else {
        window.open(
          `${baseUrl}/v1/table${indicatorsdataId}/table${indicatorsdataId}Excel?yearNo=${yearsName}`
        );
      }
      toggle();
    }
  };
  useEffect(() => {
    if (indicatorsId) {
      setIndicatorsdataId(indicatorsId);
    } else {
      setIndicatorsdataId(null);
    }
  }, [indicatorsId]);

  const getIndicatorsId = (indicatorsId) => {
    if (indicatorsId === 3 || indicatorsId === 4) {
      return 5;
    } else if (indicatorsId === 40 || indicatorsId === 41) {
      return 7;
    } else if (indicatorsId === 14) {
      return 44;
    } else if (indicatorsId === 17) {
      return null;
    } else {
      return indicatorsId;
    }
  };
  return (
    <>
      <ToastContainer />
      <Modal size="md" open={open} toggle={toggle}>
        <ModalHeader tag="h6" titleClass="bold" style={{ border: "none" }}>
          DownLoad Report
          <ModalClose onClick={toggle}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </ModalClose>
        </ModalHeader>
        <ModalBody>
          {indicatorsId !== 17 &&  indicatorsId !== 42 && (
            <Row>
              <Col md="12">
                <FormGroup>
                  <label>
                    เลือกปี พ.ศ.<span style={{ color: "red" }}>*</span>
                  </label>
                  {/* <div>
                    <CheckboxYears
                      getValue={(values) => {
                        setSelectYear(values)
                      }}
                      indicatorsDatasetSettingId={getIndicatorsId(indicatorsId)}
                    />
                  </div> */}
                  <SelectYears
                    placeholder="เลือก"
                    name="yearId"
                    onChange={(e) => {
                      setyearId(e.target.value);
                      setYearsName(
                        e.target.options[e.target.selectedIndex].text
                      );
                    }}
                    indicatorsDatasetSettingId={getIndicatorsId(indicatorsId)}
                    defaultValue={yearId}
                    value={yearId}
                  />
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <StyledModalFooter>
          <Button
            className="btn-white pull-right"
            style={{ width: "150px" }}
            onClick={() => {
              toggle();
            }}
          >
            ยกเลิก
          </Button>
          <Button
            className="btn-success pull-right"
            style={{ width: "150px" }}
            onClick={download}
            loading={loading}
            disabled={!yearId && indicatorsId !== 17 && indicatorsId !== 42}
          >
            DownLoad
          </Button>
        </StyledModalFooter>
      </Modal>
    </>
  );
};

export default ModalDeleteContentMain;
